import React from 'react';
import queryString from 'query-string';


const ConnectToSlackButton = () => {
  const oauthUrl = 'https://slack.com/oauth/v2/authorize';
  const scope = 'incoming-webhook,commands,chat:write';
  const client_id = '580659060118.2066691773859';
  const redirect_uri = 'https://app.flexbase.io/integrations/slack/';

  const params = {
    scope,
    client_id,
    redirect_uri,
    state: window.location.href,
  };

  return (
    <a href={`${oauthUrl}?${queryString.stringify(params)}`}>
      <img
        alt="Connect to Slack"
        height="40"
        width="139"
        src="https://platform.slack-edge.com/img/add_to_slack.png"
        srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
      />
    </a>
  );
};

export default ConnectToSlackButton;
